const sidebarBgColor = (state = "", action:any) => {  
    switch (action.type) {
        case 'BG_COLOR':
            return action.color
        default:
            return state
    }
}

export default sidebarBgColor